import type { MarketplaceKey } from "@porsche-customer/slfinrtl-context-types"
// eslint-disable-next-line no-restricted-imports -- the vehicle can belong to another marketplace than the current one
import { getMarketplaceConfig } from "src/common/getConfig"
import { legacyDeliveredVehicleDetailsRoute, usedDeliveredVehicleDetailsRoute } from "./deliveredVehicleDetailsRoutes"

export const getDeliveredVehicleDetailsUrlForMarketplace = (
	marketplaceKey: MarketplaceKey,
): ((vehicleKey: string) => string) =>
	getMarketplaceConfig(marketplaceKey).fulfillmentSalesEnabled === "disabled"
		? legacyDeliveredVehicleDetailsRoute.url
		: usedDeliveredVehicleDetailsRoute.url
